module.exports = __webpack_public_path__ + "static/defaultPinHover-f3b547807d506d0a265db13d8beed04b.png";